import 'regenerator-runtime/runtime';
import 'core-js';
import 'zone.js/dist/zone';

((): void => {
    if (!Element.prototype.matches) {
        // tslint:disable-next-line:no-string-literal
        Element.prototype.matches = Element.prototype['msMatchesSelector'] || Element.prototype.webkitMatchesSelector;
    }
})();
